import React, {Component} from 'react';

import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Icon from '@material-ui/core/Icon';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Divider from '@material-ui/core/Divider';

import { translate } from 'react-i18next';

import './styles/trackstrip.css';

import config from '../../../../config';

class TrackStrip extends Component {

  constructor(props) {
    super(props);
    this.state = {
      menuAnchorEl: null,
      warning: null,
      action: null,
    }
    this.executeAction=this.executeAction.bind(this);
  }

  componentWillMount() {
    const { t } = this.props;
    this.texts = t('component.module.artist.misc.TrackStrip', {returnObjects: true});
  }


  handleOpenMenu = event => {
    this.setState({ menuAnchorEl: event.currentTarget });
  };
  handleClose = () => {
    this.setState({
      menuAnchorEl: null,
      action: null,
      warning: null
    });
  };
  prepareAction = event => {
    let id = event.currentTarget.id;

    switch (id) {
      case 'delete': {
        this.setState({
          warning: this.texts.warnings.delete,
          action: 'delete',
          menuAnchorEl: null,
        })
        break;
      }
      case 'unpublish': {
        this.setState({
          warning: this.texts.warnings.unpublish,
          action: 'unpublish',
          menuAnchorEl: null,
        })
        break;
      }
      default:
      this.executeAction(id);
    }
  }
  executeAction(action = this.state.action) {
    this.props.onAction(action);
    this.handleClose();
  }



  render() {
    const track = this.props.track;
    const artists = track.artists.map(artist => artist.name);
    const stores = Object.keys(track.stores).filter(key => track.stores[key] !== '');
    const { menuAnchorEl } = this.state;

    return (
      <div className="component-module-artist-misc-TrackStrip-container">
        {
          this.props.track._hasImage ? (
            <img alt='' src={
              `${config.API_ADDRESS}/file/image/${track._id}?quality=low&dummy=${track._imgDummy}`
            }/>
          ) : (
            <img alt='' src='placeholders/album.png'/>
          )
        }
        <div className="title">
          <p> {track.title} </p>
        </div>
        <div className="artists">
          <p> {artists.join(', ')} </p>
        </div>

        <div className='stores'>
          {
            stores.map((store, key) => {
              return (
                <Tooltip key={key} title={store}>
                  <a href={track.stores[store]} target="_blank">
                  <img
                    alt='storelink'
                    src={`brandLogos/${store}_logo.png`}
                  />
                  </a>
                </Tooltip>
              )
            })
          }
        </div>

        <div className="published">
          {
            track.releaseDate ? (
              <p style={{color: 'green'}}> {track.releaseDate} </p>
            ) : (
              <p style={{color: 'red'}}> {this.texts.notReleased} </p>
            )
          }
        </div>

        <Tooltip title={this.texts.menu.tooltip} placement='left'>
          <IconButton
            aria-label="More"
            aria-owns={menuAnchorEl ? 'long-menu' : null}
            aria-haspopup="true"
            onClick={this.handleOpenMenu}
          >
            <Icon> more_vert </Icon>
          </IconButton>
        </Tooltip>
              <Menu
                id="long-menu"
                anchorEl={menuAnchorEl}
                open={Boolean(menuAnchorEl)}
                onClose={this.handleClose}
              >
                <MenuItem id='editor' onClick={this.prepareAction}>
                  <ListItemIcon>
                    <Icon> edit </Icon>
                  </ListItemIcon>
                  <ListItemText inset primary={this.texts.menu.editor} />
                </MenuItem>


                <Divider />


                <MenuItem id='downloadArtwork' onClick={this.prepareAction} disabled={Boolean(!track._hasImage)}>
                  <ListItemIcon>
                    <Icon> get_app </Icon>
                  </ListItemIcon>
                  <ListItemText inset primary={this.texts.menu.downloadArtwork} />
                </MenuItem>


                <Divider />


                <MenuItem id='unpublish' onClick={this.prepareAction} disabled={Boolean(!track.releaseDate)}>
                  <ListItemIcon>
                    <div style={{color: '#F89406'}}>
                      <Icon color='inherit'> block </Icon>
                    </div>
                  </ListItemIcon>
                  <ListItemText inset primary={this.texts.menu.unpublish} />
                </MenuItem>

                <MenuItem id='delete' onClick={this.prepareAction} disabled={Boolean(track.releaseDate)}>
                  <ListItemIcon>
                    <div style={{color: '#D91E18'}}>
                      <Icon color='inherit'> delete </Icon>
                    </div>
                  </ListItemIcon>
                  <ListItemText inset primary={this.texts.menu.delete} />
                </MenuItem>
              </Menu>






        <Dialog
          disableEscapeKeyDown
          disableBackdropClick
          open={Boolean(this.state.warning)}
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.state.warning}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.setState({
                warning: null,
                action: null,
              })}
            >
              {this.texts.consent.back}
            </Button>
            <Button
              onClick={() => this.executeAction()}
              autoFocus
            >
              <div style={{color: '#D91E18'}}>
                {this.texts.consent.continue}
              </div>
            </Button>
          </DialogActions>
        </Dialog>

      </div>
    )
  }
}
export default translate('translations')(TrackStrip);



// WEBPACK FOOTER //
// ./src/components/modules/artist/misc/TrackStrip.js